import React from 'react';
import { BasicTooltip } from '@livable/saas-react-components';
import { Typography } from '@mui/material';
import useStyles from '../styles';
import { observer } from 'mobx-react-lite';
export const UnitCell = observer(_ref => {
  let params = _ref.params;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.overflowCellWrapper, " ").concat(classes.cellLeftAlign)
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: params.row.unitName,
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.cellLeftAlign, " cellContent")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.overflowCell
  }, params.row.unitName))));
});